/**
 * Live Me Up Cart Integration for Shopify Dawn Theme
 * Insert this script in layout/theme.liquid before </body>
 */

(function() {
  'use strict';

  class ShopifyCartGateway {
    constructor() {
      this.init();
    }

    init() {
      // Set up the gateway before any other Live Me Up calls
      window.LiveMeUpCartGatewayV3 = this;
      console.log('Live Me Up Cart Gateway initialized for Dawn theme');
    }

    /**
     * Add product to Shopify cart
     */
    async addToCart({cmsProductId, quantity, cmsVariantId, videoId}) {
      try {
        // In Dawn, we need to use the variant ID for the cart
        const variantId = cmsVariantId || cmsProductId;
        
        const formData = {
          'items': [{
            'id': parseInt(variantId),
            'quantity': quantity,
            'properties': {
              '_lmu_video_id': videoId || null
            }
          }]
        };

        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify(formData)
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const result = await response.json();
        
        // Trigger Dawn's cart update
        this.triggerCartUpdate();
        
        // Return the line ID from the response
        const lineId = result.items && result.items[0] ? 
          result.items[0].key || result.items[0].id.toString() : 
          Date.now().toString();

        return { lineId };

      } catch (error) {
        console.error('Error adding to cart:', error);
        throw error;
      }
    }

    /**
     * Get current cart content
     */
    async getContent() {
      try {
        const response = await fetch('/cart.js');
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        
        const cart = await response.json();
        
        return cart.items.map(item => ({
          cmsProductId: item.product_id.toString(),
          cmsVariantId: item.variant_id ? item.variant_id.toString() : null,
          quantity: item.quantity,
          lineId: item.key || item.id.toString(),
          videoId: item.properties && item.properties._lmu_video_id ? 
            item.properties._lmu_video_id : null
        }));

      } catch (error) {
        console.error('Error getting cart content:', error);
        return [];
      }
    }

    /**
     * Update quantities in cart
     */
    async updateQuantities(products) {
      try {
        const updates = {};
        
        products.forEach(product => {
          // Use line ID as key for updates
          updates[product.lineId] = product.quantity;
        });

        const response = await fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({ updates })
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        // Trigger Dawn's cart update
        this.triggerCartUpdate();

      } catch (error) {
        console.error('Error updating quantities:', error);
        throw error;
      }
    }

    /**
     * Flag line for sale tracking
     */
    async flagLineForSaleTracking({lineId, cmsProductId, cmsVariantId, quantity, videoId, previousVideoId}) {
      try {
        // Find the specific line and update its video ID property
        const cart = await fetch('/cart.js').then(r => r.json());
        const lineItem = cart.items.find(item => 
          (item.key || item.id.toString()) === lineId
        );
        
        if (lineItem) {
          const properties = { ...lineItem.properties };
          properties._lmu_video_id = videoId;
          
          // Update the line with new video ID
          const response = await fetch('/cart/change.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body: JSON.stringify({
              id: lineItem.key || lineItem.id,
              quantity: quantity,
              properties: properties
            })
          });

          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }

          this.triggerCartUpdate();
        }

      } catch (error) {
        console.error('Error flagging line for sale tracking:', error);
        // Don't throw - this is optional functionality
      }
    }

    /**
     * Validate cart (called when proceeding to checkout)
     */
    async validateCart() {
      try {
        // Dawn theme validation - ensure cart is valid
        const response = await fetch('/cart.js');
        if (!response.ok) {
          throw new Error('Cart validation failed');
        }
        
        const cart = await response.json();
        
        // Optional: Add any custom validation logic here
        if (cart.items.length === 0) {
          throw new Error('Cart is empty');
        }
        
        console.log('Cart validated successfully');
        
      } catch (error) {
        console.error('Cart validation error:', error);
        throw error;
      }
    }

    /**
     * Trigger Dawn theme cart update events
     */
    triggerCartUpdate() {
      // Trigger Dawn's cart drawer update
      if (window.CartDrawer && window.CartDrawer.renderContents) {
        window.CartDrawer.renderContents();
      }
      
      // Dispatch custom event for any other listeners
      document.dispatchEvent(new CustomEvent('cart:updated', {
        detail: { source: 'livemeup' }
      }));
      
      // Update cart count in header
      this.updateCartCount();
    }

    /**
     * Update cart count in Dawn theme header
     */
    async updateCartCount() {
      try {
        const response = await fetch('/cart.js');
        const cart = await response.json();
        
        // Update cart count badges
        const cartCountElements = document.querySelectorAll('.cart-count-bubble span, [data-cart-count]');
        cartCountElements.forEach(element => {
          element.textContent = cart.item_count;
        });
        
        // Show/hide cart count bubble
        const cartBubbles = document.querySelectorAll('.cart-count-bubble');
        cartBubbles.forEach(bubble => {
          if (cart.item_count > 0) {
            bubble.classList.remove('cart-count-bubble--empty');
          } else {
            bubble.classList.add('cart-count-bubble--empty');
          }
        });
        
      } catch (error) {
        console.error('Error updating cart count:', error);
      }
    }
  }

  // Initialize the gateway immediately
  function initializeLiveMeUpGateway() {
    new ShopifyCartGateway();
  }

  // Initialize before DOMContentLoaded if possible
  if (document.readyState === 'loading') {
    // If DOM is still loading, initialize immediately and also on DOMContentLoaded
    initializeLiveMeUpGateway();
    document.addEventListener('DOMContentLoaded', initializeLiveMeUpGateway);
  } else {
    // DOM already loaded
    initializeLiveMeUpGateway();
  }

})();